// extracted by mini-css-extract-plugin
export var actionButton = "_kb-0";
export var fileInput = "_kb-2";
export var paperclip = "_kb-1";